import script from "./MusicSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./MusicSheet.vue?vue&type=script&setup=true&lang=js"

import "./MusicSheet.vue?vue&type=style&index=0&id=3878cbe9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3878cbe9"]])

export default __exports__